import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "mod-panel" }
const _hoisted_2 = {
  key: 0,
  class: "mod-loading"
}
const _hoisted_3 = { class: "mod-header" }
const _hoisted_4 = { class: "mod-title" }
const _hoisted_5 = { class: "mod-meta" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "mod-actions"
}
const _hoisted_9 = {
  key: 0,
  class: "mod-new-form"
}
const _hoisted_10 = { class: "mod-grid" }
const _hoisted_11 = { class: "mod-field" }
const _hoisted_12 = { class: "mod-field" }
const _hoisted_13 = {
  key: 0,
  class: "mod-error"
}
const _hoisted_14 = { class: "mod-form-actions" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "mod-items" }
const _hoisted_17 = { class: "mod-grid" }
const _hoisted_18 = { class: "mod-field" }
const _hoisted_19 = { class: "mod-field" }
const _hoisted_20 = { class: "mod-form-actions" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "mod-item-top" }
const _hoisted_23 = { class: "mod-item-title" }
const _hoisted_24 = {
  key: 0,
  class: "mod-item-desc"
}
const _hoisted_25 = {
  key: 0,
  class: "mod-item-evidence"
}
const _hoisted_26 = {
  key: 0,
  class: "mod-evidence-line"
}
const _hoisted_27 = {
  key: 1,
  class: "mod-evidence-line"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 3,
  class: "mod-evidence-meta"
}
const _hoisted_30 = {
  key: 1,
  class: "mod-review-note"
}
const _hoisted_31 = { class: "mod-item-actions" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 2,
  class: "mod-reject-form"
}
const _hoisted_37 = { class: "mod-form-actions" }
const _hoisted_38 = ["disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "mod-back",
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
    }, [...(_cache[12] || (_cache[12] = [
      _createElementVNode("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [
        _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
      ], -1),
      _createTextVNode(" Voltar ", -1)
    ]))]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando..."))
      : (_ctx.os)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_4, "OS" + _toDisplayString(_ctx.os.osNumber) + " — " + _toDisplayString(_ctx.os.title), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_ctx.os.responsaveis.join(', ')) + " ", 1),
                  (_ctx.os.dueDate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, " · prazo " + _toDisplayString(_ctx.formatDate(_ctx.os.dueDate)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.os.requireAll)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, " · todos precisam preencher"))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["mod-priority-badge", 'p-' + _ctx.os.priority])
                  }, _toDisplayString(_ctx.priorityLabel(_ctx.os.priority)), 3),
                  _createElementVNode("span", {
                    class: _normalizeClass(["mod-status-badge", 's-' + _ctx.os.status])
                  }, _toDisplayString(_ctx.statusLabel(_ctx.os.status)), 3)
                ])
              ]),
              (_ctx.accessLevel >= 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_ctx.os.status !== 'cancelled')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("button", {
                            class: "mod-btn",
                            type: "button",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddItem = !_ctx.showAddItem))
                          }, "+ Adicionar rotina"),
                          _createElementVNode("button", {
                            class: "mod-btn mod-btn-danger",
                            type: "button",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelOs && _ctx.cancelOs(...args)))
                          }, "Cancelar OS")
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.accessLevel >= 3)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "mod-btn mod-btn-danger",
                          type: "button",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deleteOs && _ctx.deleteOs(...args)))
                        }, "Apagar OS"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.showAddItem)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "mod-label" }, "Título da rotina", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: "mod-input",
                        type: "text",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newItem.title) = $event)),
                        placeholder: "Ex.: Verificar extintores"
                      }, null, 512), [
                        [_vModelText, _ctx.newItem.title]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[14] || (_cache[14] = _createElementVNode("label", { class: "mod-label" }, "Descrição (opcional)", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: "mod-input",
                        type: "text",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newItem.description) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.newItem.description]
                      ])
                    ])
                  ]),
                  (_ctx.addItemError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.addItemError), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                      class: "mod-btn mod-btn-primary",
                      type: "button",
                      disabled: _ctx.addingItem,
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submitAddItem && _ctx.submitAddItem(...args)))
                    }, _toDisplayString(_ctx.addingItem ? 'Adicionando...' : 'Adicionar rotina'), 9, _hoisted_15)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.os.items, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "mod-item-card"
                }, [
                  (_ctx.editingItem === item.id)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _cache[15] || (_cache[15] = _createElementVNode("label", { class: "mod-label" }, "Título", -1)),
                            _withDirectives(_createElementVNode("input", {
                              class: "mod-input",
                              type: "text",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editItemForm.title) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.editItemForm.title]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _cache[16] || (_cache[16] = _createElementVNode("label", { class: "mod-label" }, "Descrição", -1)),
                            _withDirectives(_createElementVNode("input", {
                              class: "mod-input",
                              type: "text",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editItemForm.description) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.editItemForm.description]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("button", {
                            class: "mod-btn",
                            type: "button",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editingItem = ''))
                          }, "Cancelar"),
                          _createElementVNode("button", {
                            class: "mod-btn mod-btn-primary",
                            type: "button",
                            onClick: ($event: any) => (_ctx.submitEditItem(item.id))
                          }, "Salvar", 8, _hoisted_21)
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_23, _toDisplayString(item.title), 1),
                            (item.description)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(item.description), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(["mod-status-badge", 's-' + item.status])
                          }, _toDisplayString(_ctx.itemStatusLabel(item.status)), 3)
                        ]),
                        (item.status !== 'pending' || item.completedAt)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              (item.textResponse)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(item.textResponse), 1))
                                : _createCommentVNode("", true),
                              (item.checkResponse)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, "✓ Marcado como feito"))
                                : _createCommentVNode("", true),
                              (item.photoResponse)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 2,
                                    src: item.photoResponse,
                                    class: "mod-evidence-photo",
                                    alt: "Evidência"
                                  }, null, 8, _hoisted_28))
                                : _createCommentVNode("", true),
                              (item.completedByName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, "Concluído por " + _toDisplayString(item.completedByName) + " em " + _toDisplayString(_ctx.formatDateTime(item.completedAt)), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (item.reviewNotes && item.status === 'pending')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, " Reprovado por " + _toDisplayString(item.reviewedByName) + ": " + _toDisplayString(item.reviewNotes), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_31, [
                          (_ctx.accessLevel >= 3 && item.status === 'done')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("button", {
                                  class: "mod-btn mod-btn-primary",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.approve(item.id))
                                }, "Aprovar", 8, _hoisted_32),
                                _createElementVNode("button", {
                                  class: "mod-btn mod-btn-danger",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.openReject(item.id))
                                }, "Reprovar", 8, _hoisted_33)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.accessLevel >= 2 && _ctx.os.status !== 'cancelled')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("button", {
                                  class: "mod-btn",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.openEditItem(item))
                                }, "Editar", 8, _hoisted_34),
                                _createElementVNode("button", {
                                  class: "mod-btn mod-btn-danger",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.removeItem(item.id))
                                }, "Remover", 8, _hoisted_35)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.rejecting === item.id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _withDirectives(_createElementVNode("textarea", {
                                class: "mod-textarea",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.rejectNotes) = $event)),
                                rows: "2",
                                placeholder: "Motivo da reprovação (obrigatório)"
                              }, null, 512), [
                                [_vModelText, _ctx.rejectNotes]
                              ]),
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("button", {
                                  class: "mod-btn",
                                  type: "button",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.rejecting = ''))
                                }, "Cancelar"),
                                _createElementVNode("button", {
                                  class: "mod-btn mod-btn-danger",
                                  type: "button",
                                  disabled: !_ctx.rejectNotes.trim(),
                                  onClick: ($event: any) => (_ctx.reject(item.id))
                                }, "Confirmar reprovação", 8, _hoisted_38)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                ]))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true)
  ]))
}